import { Injectable } from '@angular/core';
// import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
// import { debounceTime } from 'rxjs/operators';
import { LogService, IAuthenticationService, PershingError, ServiceRouter } from '@pershing/pershing-core';
import { Email } from './../models/e-mail.model';
import { Emailresponse } from './../models/emailresponse.model';
import { EdeliveryServiceDefinition } from './../models/router-service-definition';
import { HttpHeaders } from '@angular/common/http';
import { EDeliveryService } from '../services/edelivery.service';

let headers = new HttpHeaders({
    'Content-Type': 'application/json'
});

/**
 * @desc interacts with the backend services to fetch the data and updates the data.
 */
@Injectable()
export class EMailService {
    private baseUrl = '';
    emailresponse$: Observable<Emailresponse>;
    error$: Observable<PershingError>;
    private _emailsResponse: Subject<Emailresponse>;
    private _error: BehaviorSubject<PershingError>;
    private dataStore: {
        emailsResponse: Emailresponse;
    };

    emailUpdatedFlag: boolean = false;
    updateEmailTriggered: boolean = false;
    showEmailPopup = false;
    EmailPopupAlreadyTriggered = false;

    addEmailObservable$: Observable<boolean>;
    private _addEmailObservable: BehaviorSubject<boolean>;

    addEmailInProgressFlag: boolean = false;
    deleteEmailInProgressFlag: boolean = false;
    updateEmailInProgressFlag: boolean = false;
    enrollAllInProgressFlag: boolean = false;
    // updateEmail1: string = '';
    // updateEmail2: string = '';
    // showUpdateEmail2 = false;

    constructor(private logService: LogService, private http: HttpClient, private authenticationService: IAuthenticationService, private serviceRouter: ServiceRouter,
                private eDeliveryService: EDeliveryService) {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this._emailsResponse = <BehaviorSubject<Emailresponse>>new BehaviorSubject(null);
        this.emailresponse$ = this._emailsResponse.asObservable();
        this.dataStore = { emailsResponse: null };
        this.baseUrl = this.serviceRouter.getServiceRouteURL( EdeliveryServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } } );
        // this.baseUrl = 'http://localhost:4200/dev-edc-newedelivery-service-service/edc/edelivery';

        this._addEmailObservable = new BehaviorSubject<boolean>(false);
        this.addEmailObservable$ = this._addEmailObservable.asObservable();

        this.emailresponse$.subscribe(response => { // Subscribe to the Observable which gets updated from the email.service.ts
            if (response && this.updateEmailTriggered === true) {
              console.log('save email response ---: ', response);
              this.emailUpdatedFlag = true;
              this.eDeliveryService.retrievePreferences();
            //   this.updateEmailTriggered = false;
            //   this.eDeliveryService.triggerLoadingIcon(true);
            }
        });
    }
    getUserEmails(): Email[] {
        return this.dataStore.emailsResponse.emails;
    }
    retrieveEmails(): void {
        let url: string = this.baseUrl + '/retrieveEmail';
        if (!this.eDeliveryService.isNXIRequest()) {
            url = url + '/' + this.eDeliveryService.contextData.ibdId + '/' + this.eDeliveryService.contextData.subscriberId;
        }
        // if (this.eDeliveryService.isNXIRequest() && !this.authenticationService.isLoggedIn()) {
        //     console.log('User not logged in');
        //     return;
        // }
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/retrieveEmail/PPA/JAYANTQA';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/retrieveEmail/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/retrieveEmail/3CR/MOHEDEL2';
        // if (this.authenticationService.isLoggedIn()) {
            this.http.get(`${url}`, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.log(data);
                        console.log('email data: ', data);
                        let emailsResponse: Emailresponse = new Emailresponse();
                        emailsResponse.emails = data.response;
                        this.dataStore.emailsResponse = emailsResponse;
                        this._emailsResponse.next(Object.assign({}, this.dataStore).emailsResponse);
                        this.logService.info('retrieve emails success: ', data.errorCode);
                        this.logService.info('retrieve emails success success: ', data);
                        this.clearError();
                    } else { // error code from backend
                        this.logService.error('retrieveEmails() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                },
                    error => {
                        this.setError(error);
                    });
        // } else {
        //     console.log('User not logged in');
        // }
    }

    addEmails(email: Email): void {
        if (!this.addEmailInProgressFlag) {
            this.addEmailInProgressFlag = true;
        } else {
            return;
        }
        let url: string = this.baseUrl + '/addEmails/true';
        if (!this.eDeliveryService.isNXIRequest()) {
            url = url + '/' + this.eDeliveryService.contextData.ibdId + '/' + this.eDeliveryService.contextData.subscriberId;
        }
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/addEmails/PPA/JAYANTQA/true/';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/addEmails/true/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/addEmails/true/3CR/MOHEDEL2';
        let emails: Email[] = new Array();
        emails.push(email);
        let body = emails;
        console.log('update emails body: ', body);
        // if (this.eDeliveryService.isNXIRequest() && !this.authenticationService.isLoggedIn()) {
        //     console.log('User not logged in');
        //     return;
        // }
        // if (this.authenticationService.isLoggedIn()) {
            this.http.post(`${url}`, body, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('update emails success: ', data.errorCode);
                        this.logService.info('update emails success success: ', data);
                        this.clearError();
                        console.log('service emailResponse for adding email', data);
                        let emailsResponse: Emailresponse = new Emailresponse();
                        emailsResponse.emails = data.response;
                        this.dataStore.emailsResponse = emailsResponse;
                        this._emailsResponse.next(Object.assign({}, this.dataStore).emailsResponse);
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                    this.addEmailInProgressFlag = false;
                },
                    error => {
                        this.addEmailInProgressFlag = false;
                        this.setError(error);
                    });
        // } else {
        //     console.log('User not logged in');
        // }
    }

    addEmailFromPending() {
        // Call an observable to trigger the Add Email component
        this._addEmailObservable.next(true);
    }

    updateEmails(email: Email): void {
        if (!this.updateEmailInProgressFlag) {
            this.updateEmailInProgressFlag = true;
        } else {
            return;
        }
        let url: string = this.baseUrl + '/updateEmails/true';
        if (!this.eDeliveryService.isNXIRequest()) {
            url = url + '/' + this.eDeliveryService.contextData.ibdId + '/' + this.eDeliveryService.contextData.subscriberId;
        }
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/updateEmails/true/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/updateEmails/true/3CR/MOHEDEL2';
        let emails: Email[] = new Array();
        emails.push(email);
        let body = emails;
        // this.eDeliveryService.triggerLoadingIcon(true);
        console.log('update emails body: ', body);
        // if (this.eDeliveryService.isNXIRequest() && !this.authenticationService.isLoggedIn()) {
        //     console.log('User not logged in');
        //     return;
        // }
        // if (this.authenticationService.isLoggedIn()) {
            this.http.post(`${url}`, body, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('update emails success: ', data.errorCode);
                        this.logService.info('update emails success success: ', data);
                        this.clearError();
                        console.log('service emailResponse', data);
                        let emailsResponse: Emailresponse = new Emailresponse();
                        emailsResponse.emails = data.response;
                        this.dataStore.emailsResponse = emailsResponse;
                        this._emailsResponse.next(Object.assign({}, this.dataStore).emailsResponse);
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                    this.updateEmailInProgressFlag = false;
                },
                    error => {
                        this.updateEmailInProgressFlag = false;
                        this.setError(error);
                    });
        // } else {
        //     console.log('User not logged in');
        // }
    }

    updateAllEmails(emails: Email[]): void {
        if (!this.updateEmailInProgressFlag) {
            this.updateEmailInProgressFlag = true;
        } else {
            return;
        }
        let url: string = this.baseUrl + '/updateAllEmails/true';
        if (!this.eDeliveryService.isNXIRequest()) {
            url = url + '/' + this.eDeliveryService.contextData.ibdId + '/' + this.eDeliveryService.contextData.subscriberId;
        }
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/updateEmails/true/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/updateEmails/true/3CR/MOHEDEL2';
        let body = emails;
        // this.eDeliveryService.triggerLoadingIcon(true);
        console.log('update emails body: ', body);
        // if (this.eDeliveryService.isNXIRequest() && !this.authenticationService.isLoggedIn()) {
        //     console.log('User not logged in');
        //     return;
        // }
        // if (this.authenticationService.isLoggedIn()) {
            this.http.post(`${url}`, body, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('update emails success: ', data.errorCode);
                        this.logService.info('update emails success success: ', data);
                        this.clearError();
                        console.log('service emailResponse', data);
                        let emailsResponse: Emailresponse = new Emailresponse();
                        emailsResponse.emails = data.response;
                        this.dataStore.emailsResponse = emailsResponse;
                        this._emailsResponse.next(Object.assign({}, this.dataStore).emailsResponse);
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                    this.updateEmailInProgressFlag = false;
                },
                    error => {
                        this.updateEmailInProgressFlag = false;
                        this.setError(error);
                    });
        // } else {
        //     console.log('User not logged in');
        // }
    }


    deleteEmail(email: Email): void {
        if (!this.deleteEmailInProgressFlag) {
            this.deleteEmailInProgressFlag = true;
        } else {
            return;
        }
        let url: string = this.baseUrl + '/deleteEmails';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/deleteEmails/PPA/JAYANTQA';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/deleteEmails';
        let seqNumber = email.emailSeqNum;
        let emailAddress = email.emailAddress;
        // if (this.eDeliveryService.isNXIRequest() && !this.authenticationService.isLoggedIn()) {
        //     console.log('User not logged in');
        //     return;
        // }
        // if (this.authenticationService.isLoggedIn()) {
            url = url + '/' + emailAddress + '/' + seqNumber + '/true';
            if (!this.eDeliveryService.isNXIRequest()) {
                url = url + '/' + this.eDeliveryService.contextData.ibdId + '/' + this.eDeliveryService.contextData.subscriberId;
            }
            // this.http.delete(`${url}/${emailAddress}/${seqNumber}/true/3CR/EDTEST`, { headers: headers })
            // this.http.delete(`${url}/${emailAddress}/${seqNumber}/true/3CR/MOHEDEL2`, { headers: headers })
            this.http.delete(`${url}`, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('update emails success: ', data.errorCode);
                        this.logService.info('update emails success success: ', data);
                        this.clearError();
                        let emailsResponse: Emailresponse = new Emailresponse();
                        emailsResponse.emails = data.response;
                        this.dataStore.emailsResponse = emailsResponse;
                        this._emailsResponse.next(Object.assign({}, this.dataStore).emailsResponse);
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                    this.deleteEmailInProgressFlag = false;
                },
                    error => {
                        this.deleteEmailInProgressFlag = false;
                        this.setError(error);
                    });
        // } else {
        //     console.log('User not logged in');
        // }
    }

    oneClickEnroll(emails: Email[]): void {
        if (!this.enrollAllInProgressFlag) {
            this.enrollAllInProgressFlag = true;
        } else {
            return;
        }
        let url: string = this.baseUrl + '/enrollAll/true';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/updateEmails/true/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-newedelivery-service-service/edc/edelivery/updateEmails/true/3CR/MOHEDEL2';
        // let emails: Email[] = new Array();
        // emails.push(email);
        let body = emails;
        // this.eDeliveryService.triggerLoadingIcon(true);
        console.log('update emails body: ', body);
        // if (this.authenticationService.isLoggedIn()) {
            this.http.post(`${url}`, body, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('update emails success: ', data.errorCode);
                        this.logService.info('update emails success success: ', data);
                        this.clearError();
                        console.log('service emailResponse', data);
                        let emailsResponse: Emailresponse = new Emailresponse();
                        emailsResponse.emails = data.response;
                        this.dataStore.emailsResponse = emailsResponse;
                        this._emailsResponse.next(Object.assign({}, this.dataStore).emailsResponse);
                        document.dispatchEvent(new CustomEvent('portal.nxiOneClickAcceptEvent'));
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                    this.enrollAllInProgressFlag = false;
                },
                    error => {
                        this.enrollAllInProgressFlag = false;
                        this.setError(error);
                    });
        // } else {
        //     console.log('User not logged in');
        // }
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'EMailService', errorCode));
    }

    clearError(): void {
        this._error.next(null);
    }
}
